// Site-wide content: contact details, links and the "How it works" copy.
// Sources: askjoan.co.uk contact page, the Ask Joan EULA and the Viviplu privacy policy.
import feelingUnsafe from '../assets/how-it-works/feeling-unsafe.png';
import householdAppliance from '../assets/how-it-works/household-appliance.png';
import energySurge from '../assets/how-it-works/energy-surge.png';
import helpAtHand from '../assets/how-it-works/help-at-hand.png';

export const SUPPORT = {
  phone: '0203 872 8069',
  phoneHref: 'tel:+442038728069',
  hours: 'Monday to Friday, 8am to 8pm',
  email: 'info@viviplu.co.uk',
};

export const COMPANY = {
  name: 'Viviplu Limited',
  number: '16102436',
  registeredOffice: '1 London Road, Southampton, SO15 2AE',
};

// Shown wherever we talk about alerts: Joan is not an emergency service (EULA clause 3.2)
export const EMERGENCY = {
  line: 'Joan is not a personal alarm and cannot contact the emergency services. If you are in danger, call 999.',
  silentSolution: 'If you call 999 from a mobile and cannot speak, stay on the line and press 55 when prompted so the police know it is a genuine emergency.',
  helplineName: 'National Domestic Abuse Helpline (free, 24 hours)',
  helplinePhone: '0808 2000 247',
  helplineHref: 'tel:+448082000247',
};

export const COMPATIBILITY_CHECK_URL =
  'https://ivie.co.uk/compatibility/?srsltid=AfmBOoro3haB3nVXjpVtl2Q9JFVC70W66oWbPu6RvNDzHQZOTmxH1t9T';

export const SOCIAL_LINKS = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/viviplu-ltd/' },
  { label: 'YouTube', href: 'https://www.youtube.com/channel/UCTI5CBry0LZmrgLNbycCOUA' },
  { label: 'X', href: 'https://x.com/cyrilinsights' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@cyril.insights' },
];

// Quick exit lands on an everyday page that gives nothing away
export const QUICK_EXIT_URL = 'https://www.bbc.co.uk/weather';

// Wording follows EULA clause 3.1
export const HOW_IT_WORKS = [
  {
    image: feelingUnsafe,
    title: 'You feel unsafe at home',
    text: 'You do not need to reach for your phone or say a word.',
  },
  {
    image: householdAppliance,
    title: 'Switch an appliance on and off',
    text: 'Turn a high-powered appliance, like your kettle, on and off repeatedly.',
  },
  {
    image: energySurge,
    title: 'Joan spots the pattern',
    text: 'Joan works with your electricity smart meter and recognises the unusual surge.',
  },
  {
    image: helpAtHand,
    title: 'Your contacts get a text',
    text: 'Up to three people you trust receive a text message alert.',
  },
];
